'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createDatasourceMappings = function createDatasourceMappings(formId, properties) {
  if (!window.fs_mappings) {
    window.fs_mappings = {};
  }

  if (!window.fs_mappings[formId]) {
    window.fs_mappings[formId] = {
      filters: {},
      drop: {}
    };
  }

  var allProperties = (0, _keys2.default)(properties);

  if (properties) {
    (0, _keys2.default)(properties).forEach(function (key) {
      var field = properties[key];

      if (field.itemsDataSourceFilters) {
        var parts = field.itemsDataSourceFilters.split('&');

        parts.forEach(function (part) {
          var fieldParts = part.split('=');

          if (fieldParts.length === 2) {
            var isExists = allProperties.indexOf(fieldParts[1]) !== -1;

            if (isExists) {
              if (!window.fs_mappings[formId].drop[fieldParts[1]]) {
                window.fs_mappings[formId].drop[fieldParts[1]] = [];
              }

              if (!window.fs_mappings[formId].filters[key]) {
                window.fs_mappings[formId].filters[key] = [];
              }

              window.fs_mappings[formId].drop[fieldParts[1]].push(key);
              window.fs_mappings[formId].filters[key].push({
                nameInDataSource: fieldParts[0],
                nameInForm: fieldParts[1]
              });
            }
          }
        });
      }
    });
  }
};

exports.default = createDatasourceMappings;


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/utils/createDatasourceMappings.js
// module id = 1128
// module chunks = 5